import React from 'react';
import PropTypes from 'prop-types';
import clone from 'ramda/src/clone';
import isNil from 'ramda/src/isNil';
import keys from 'ramda/src/keys';
import length from 'ramda/src/length';
import values from 'ramda/src/values';
import moment from 'moment';
import classNames from 'classnames';
import Button from '@components/@core/AnimatedButton';
import Icon from '@components/@core/Icon';

class Edit extends React.PureComponent {
    state = {};

    handleAddLevel = () => {
        let program = clone(this.props.program);
        if (!program?.data?.levels) return;

        const levels = values(program.data.levels);
        const key = length(levels) + 1;
        program.data.levels[key] = {
            title: '',
            chronology_lock: false,
            time_lock: false,
            habits: {
                day: [],
                week: [],
                month: [],
            },
            quotas: [],
            trainings: {
                days_to_complete: '',
                items: [],
            },
            started_at: null,
        };
        this.props.onChange(program);
    };

    handleDeleteLevel = (level) => {
        let program = clone(this.props.program);
        if (!program?.data?.levels) return;

        let levels = clone(program.data.levels);
        let _levels = {};
        keys(levels).forEach((key) => {
            if (Number(key) !== level) {
                _levels[key] = levels[key];
            }
        });
        program.data.levels = _levels;
        this.props.onChange(program);
    };

    render() {
        const { className, current, program } = this.props;
        const levels = values(program?.data?.levels || {});

        return (
            <div className={classNames('career-map', className)}>
                <div className="header">
                    <span className="dsl-b22 bold">Health Plan Map</span>
                </div>
                <div className="map-header">
                    <span className="d-flex-5 dsl-m12">Level</span>
                    <span className="d-flex-2 dsl-m12 text-end">Started</span>
                    <span className="d-flex-3 dsl-m12 text-end">Completed</span>
                    <span className="d-flex-1" />
                </div>
                {levels.length === 0 ? (
                    <div className="map-item">
                        <p className="dsl-m14">No Career program level assigned.</p>
                    </div>
                ) : (
                    levels.map(({ title, started_at, completed_at }, index) => {
                        const isCompleted = !isNil(completed_at);
                        const isCurrent = current === index + 1;
                        return (
                            <div className="map-item" key={`level-${index}`}>
                                <div className="d-flex d-flex-5 career-name">
                                    {isCompleted ? <Icon name="fas fa-check" color="#c3c7cc" size={14} /> : <div className="check" />}
                                    <span className={`dsl-${isCurrent ? 'b16 text-400' : 'l16'} ${isCompleted ? 'line-through' : ''} truncate-one`}>{title}</span>
                                    <div className="career-name-modal dsl-b16 text-400">{title}</div>
                                </div>
                                <span className={`d-flex-2 text-end dsl-${isCurrent ? 'b16 text-400' : 'l16'}`}>{!isNil(started_at) ? moment.utc(started_at).local().format('MMM D, YY') : ''}</span>
                                <span className={`d-flex-3 text-end dsl-${isCurrent ? 'b16 text-400' : 'l16'}`}>
                                    {isCompleted && moment.utc(completed_at).local().format('MMM D, YY')}
                                    {isNil(started_at) && 'Not started'}
                                    {!isNil(started_at) && isCurrent && 'In Progress'}
                                </span>
                                <div className="d-flex d-flex-1 justify-content-end" onClick={this.handleDeleteLevel(index + 1)}>
                                    <Icon name="fas fa-trash cursor-pointer" color="#969faa" size={12} />
                                </div>
                            </div>
                        );
                    })
                )}
                <div className="d-flex justify-content-end">
                    <Button className="mt-2" type="link" onClick={this.handleAddLevel}>
                        <Icon name="fas fa-plus" size={14} color="#376caf" />
                        <span className="dsl-p14 text-400 ms-1 text-nowrap">ADD LEVEL</span>
                    </Button>
                </div>
            </div>
        );
    }
}

Edit.propTypes = {
    program: PropTypes.any,
    current: PropTypes.number,
};

Edit.defaultProps = {
    program: {},
    current: 1,
};

export default Edit;
